export const ellipsis = (text: string | undefined, maxLength: number): string => {
    if(!text) {
        return "";
    } 
    if(text.length <= maxLength) {
        return text;
    }
    return `${text.substring(0,maxLength)}...`;
}